export const EXPERT_TAB_LABEL = 'Experts';
export const PEOPLE_TAB_LABEL = 'People';
export const COMPNAY_TAB_LABEL = 'People';
export const STACKOVERFLOW_TAB_LABEL= 'Stackoverflow';
export const BOTH_PEOPLE_STACKOVERFLOW_TAB_LABELL= 'Stackoverflow';
export const LLM_USAGE_INFO_TO_USER = "Directory Services utilize OpenAI's Large Language Model within the Einstein LLM Gateway for specific search functionalities";
export const DIRECTORY_SERVICE_URL = {
  'DEV':"http://127.0.0.1:5000/",
  'PROD':"https://directory-service.herokuapp.com/",
  'STAGE_old': "https://directory-service-stage-728283226509.herokuapp.com/",
  'STAGE':"https://directory-service.sfproxy.controltelemetry-s.aws-esvc1-useast2.aws.sfdc.cl/",
  'FALCON': "https://directory-service.sfproxy.controltelemetry-s.aws-esvc1-useast2.aws.sfdc.cl/",
  'FALCON_PROD': "https://directory-service.sfproxy.controltelemetry.aws-esvc1-useast2.aws.sfdc.cl/"
}

export const ADMIN = 'Admin';
export const SALESFORCE_EMAIL_EXPRESSION = /^([A-Za-z0-9]+[.-_])*[A-Za-z0-9]+@(salesforce\.com)+$/;
export const LOAD_DATA_FROM_CACHE = false;
export const CLIENT_ID = {
  "DEV" : '335131290718-oq0fi2sf0jn8ndmmpmqkmb1stt2f7knu.apps.googleusercontent.com',
  "PROD" : '325801515390-56cebndipcjo3evuibv35jdon2oitjt0.apps.googleusercontent.com',
  "STAGE" : '325801515390-56cebndipcjo3evuibv35jdon2oitjt0.apps.googleusercontent.com',
  "FALCON" : '325801515390-56cebndipcjo3evuibv35jdon2oitjt0.apps.googleusercontent.com',
  "FALCON_PROD": '325801515390-56cebndipcjo3evuibv35jdon2oitjt0.apps.googleusercontent.com'
};
